import axios from "axios";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("rdv_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function downloadCsv(path, filename) {
  const t = localStorage.getItem("rdv_token");
  const r = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${t}` } });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const blob = await r.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
